import { UISerializableSwapRecord } from '@drift/common';
import TableV2 from '../Tables/TableV2';
import formatNumber from 'src/utils/formatNumber/formatNumber';
import { ArrowRight, Open } from '@drift-labs/icons';
import { TokenPairLogos } from '../Utils/MarketIcon';
import { getColorVar } from 'src/utils/theme/colorVars';
import useSwapHistoryTableData from 'src/components/Swap/hooks/useSwapHistoryTableData';
import Link from 'src/components/primitives/Link/Link';

const SwapHistoryTableRow = ({
	swap,
	tableGrid,
	displayDatesAsTimestamp,
	isSellDirection,
}: {
	swap: UISerializableSwapRecord;
	tableGrid: string;
	displayDatesAsTimestamp: boolean;
	isSellDirection: boolean;
}) => {
	const {
		amountIn,
		amountOut,
		fromMarketSymbol,
		toMarketSymbol,
		inMarket,
		outMarket,
		swapPriceText,
		dateFromTimestamp,
		scannerUrl,
	} = useSwapHistoryTableData({ swap, isSellDirection });

	return (
		<TableV2.BodyRow grid={tableGrid} isDataRow className="h-13 border-0">
			<TableV2.DateCell
				date={dateFromTimestamp}
				displayAsTimestamp={displayDatesAsTimestamp}
			/>

			<TableV2.BodyCell>
				<div className="flex gap-x-sm">
					<TokenPairLogos
						fromTokenSymbol={fromMarketSymbol ?? ''}
						toTokenSymbol={toMarketSymbol ?? ''}
						size={24}
					/>
					<div className="flex items-center gap-x-xs">
						{formatNumber(amountIn, {
							type: 'number',
							precision: 'trade',
							trimZeroes: true,
							suffix: inMarket.uiSymbols.baseAssetSymbol,
						})}
						<ArrowRight color={getColorVar('text-secondary')} />
						{formatNumber(amountOut, {
							type: 'number',
							precision: 'trade',
							trimZeroes: true,
							suffix: outMarket.uiSymbols.baseAssetSymbol,
						})}
					</div>
				</div>
			</TableV2.BodyCell>

			<TableV2.BodyCell>{swapPriceText}</TableV2.BodyCell>

			<TableV2.BodyCell>
				<Link
					variant="secondary"
					href={scannerUrl}
					openInNewTab
					rightIcon="none"
				>
					<Open size={16} />
				</Link>
			</TableV2.BodyCell>
		</TableV2.BodyRow>
	);
};

export default SwapHistoryTableRow;
